import { oc } from '@orpc/contract';
import { createScenarioInputSchema, scenarioSchema } from '../schemas/scenarios.schemas.js';
export const createScenarioContract = oc
    .route({
    method: 'POST',
    path: '/scenarios',
    tags: ['Scenarios'],
    summary: 'Create a test scenario',
    description: 'MANAGER only. The dimension tuple (protocol, test type, season, time band, HVAC, route type, idle duration) must be unique.',
})
    .input(createScenarioInputSchema)
    .output(scenarioSchema);
//# sourceMappingURL=create-scenario.contract.js.map